import { React, useState, useEffect } from 'react';
import Select from "react-select";
import LeaseApiService from '../../services/apiService';

const BuyerSummery = ({ tableLoading, setTransectionData, transectionData }) => {
    const apiService = new LeaseApiService();

    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            return updatedData;
        });
    };

    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                {/* <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))', gap: '20px' }}> */}
                <div className="form-group">
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">Due to Seller on Transfer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.sellerTransfer}
                            onChange={handleInputChange} name="sellerTransfer" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Balance to Developer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.developerBalance} onChange={handleInputChange} name="developerBalance" /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.developerBalancePerc} onChange={handleInputChange} name="developerBalancePerc" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1 start">Commission Paid By Buyer</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.BuyerCommission} onChange={handleInputChange} name="BuyerCommission" /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.BuyerCommissionPerc} onChange={handleInputChange} name="BuyerCommissionPerc" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1 start">Transfer Fee to DLD</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.DlDTransfer} onChange={handleInputChange} name="DlDTransfer" /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.DlDTransferPerc} onChange={handleInputChange} name="DlDTransferPerc" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1 start">Administration Fee</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.administrationFee} onChange={handleInputChange} name="administrationFee" /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.administrationFeePerc} onChange={handleInputChange} name="administrationFeePerc" /></div>
                    </div>
                    <div className="row my-2">
                        <div className=" col-3"><label className="form-label pt-1">Other Fee</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.otherFee} onChange={handleInputChange} name="otherFee" /></div>
                        <div className=" col-1"><h8 className='center p-1'>%</h8></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.otherFeePerc} onChange={handleInputChange} name="otherFeePerc" /></div>
                    </div>
                    <div className="row">
                        <div className=" col-3"><label className="form-label pt-1">All in Price</label></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.allPrice} onChange={handleInputChange} name="allPrice" /></div>
                        <div className=" col-1"><h6 className='center p-1'>%</h6></div>
                        <div className=" col-3"><input type="text" className="p-2 form-control" value={transectionData?.allPricePerc} onChange={handleInputChange} name="allPricePerc" /></div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default BuyerSummery